import { Component, OnInit,ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MessagesGeneral, MessagesTitles,MessagesStatus } from '../../../models/messages';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl} from '@angular/forms';
import Swal from "sweetalert2";
import { ReportesService } from '../../../services/reportes/reportes.service';
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-listado-pago-adq',
  templateUrl: './listado-pago-adq.component.html',
  styleUrls: ['./listado-pago-adq.component.scss'],
  providers:[MessagesTitles,MessagesGeneral, MessagesStatus,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class ListadoPagoAdqComponent implements OnInit {
  Label_id_soles=environment.ID_GUIA_SOLES;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns = ['checked','idCabecera','Fecha','Moneda','Cuenta','Banco','Estado'];

  data : any = {"Cabecera" : [], "Detalle" : []}
  arrayCabecera :any;
  arrayDetalle :any;


  filterValues = {
    Moneda: '',
    Estado: ''
  };
  
  monedaFilter = new FormControl('');
  estadoFilter = new FormControl('');
  abrirDetalle : boolean = false;
  loading:boolean ;
  dataSource:any;
  planillas:any = [];

  constructor(private reporteService:ReportesService,
              private msgTitulos : MessagesTitles,
              private msgStatus:MessagesStatus) {
      this.filtradoPagosAdquirente();
}

ngOnInit() {
  this.monedaFilter.valueChanges
      .subscribe(
        Moneda => {
          this.filterValues.Moneda = Moneda;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
  this.estadoFilter.valueChanges
      .subscribe(
        Estado => {
          this.filterValues.Estado = Estado;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )    
}

createFilter(): (data: any, filter: string) => boolean {
  return function(data, filter): boolean {
    let searchTerms = JSON.parse(filter);
    return  data.Moneda_Dsc.toString().toLowerCase().indexOf(searchTerms.Moneda) !== -1
    && data.Estado.toString().toLowerCase().indexOf(searchTerms.Estado) !== -1
  }
}

filtradoPagosAdquirente(){
  this.loading = true;
  this.reporteService.ObtenerReportePagodeAdquirentes().subscribe( resp => { 
    this.data = resp;
    this.arrayCabecera = this.data.Cabecera;
    this.arrayDetalle = this.data.Detalle;

    this.dataSource = new MatTableDataSource(this.arrayCabecera);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.filterPredicate = this.createFilter();
    this.loading = false;
   
  }, (err: HttpErrorResponse)=> {
    this.loading = false;
    if (err.error instanceof ErrorEvent) {
      console.error("Error Event");
  } else {
      this.msgStatus.getMessage(err.status);            
  }
  Swal.fire({
    title: this.msgTitulos.Error,
    text: "Lista del reporte no obtenida. "+this.msgStatus.message,
    type: "error",
    allowOutsideClick: false
  });
  })  

}


AbrirDetalle(id:number){
  this.reporteService.idDesembolso = id;
  this.reporteService.datos = this.arrayDetalle.filter(
    array => array.idCabecera == id
  );
  if (this.reporteService.datos.length > 0) {
    this.abrirDetalle = true;
  }
}
CerrarPopUp(){
  this.abrirDetalle = false;
}

}
